import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";


const Header = ({ institute, standardName, sectionName }) => (
  <View style={styles.header}>
    <View style={styles.logoContainer}>
      {institute?.instituteLogo && (
        <Image
          src={institute.instituteLogo}
          style={styles.logo}
        />
      )}
    </View>

    <View style={styles.titleContainer}>
      <Text style={styles.schoolName}>
        {institute?.instituteName}
      </Text>

      <Text style={styles.address}>
        {institute?.instituteAddress}
      </Text>

      <Text style={styles.contact}>
        Contact: {institute?.instituteMobileNo} | Email: {institute?.instituteEmail}
      </Text>

      <Text style={styles.title}>
        Due Report
      </Text>


    </View>
  </View>
);

const styles = StyleSheet.create({

  page: {
    padding: 20,
    fontSize: 10
  },


  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: "#cfcfcf",
    paddingBottom: 10,
  },

  logoContainer: {
    width: 80,
    justifyContent: "center",
    alignItems: "center",
  },

  titleContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 80, // balances the logo width
  },

  logo: {
    width: 65,
    height: 65,
    objectFit: "contain",
  },

  schoolName: {
    fontSize: 18,
    fontWeight: "bold",
  },

  address: {
    fontSize: 9,
    marginTop: 2,
  },
  head: {
    backgroundColor: "#eeeeee",
    fontWeight: "bold",
  },

  table: {
    display: "table",
    width: "100%",
    marginTop: 5,
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  },
  contact: {
    fontSize: 9,
    marginTop: 2,
  },

  title: {
    marginTop: 8,
    fontSize: 14,
    fontWeight: "bold",
  },

  subTitle: {
    marginTop: 4,
    fontSize: 10,
  },


  row: {
    flexDirection: "row",
    alignItems: "center",
  },



  cell: {
    padding: 4,
    fontSize: 10,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  }

});


const DueReport = ({
  report,
  standardName,
  sectionName
}) => {

  const students = report.data || [];
  const installmentColumns = report.installmentColumns || [];
  const institute = report.institute;
  const grandTotals = {};
  let overallTotal = 0;

  installmentColumns.forEach(column => {
    grandTotals[column] = 0;
  });

  students.forEach(student => {

    installmentColumns.forEach(column => {

      grandTotals[column] += Number(
        student.installments?.[column]?.due || 0
      );

    });

    overallTotal += Number(student.totalDue || 0);

  });
  const fixedWidth = 55;

  const dynamicWidth =
    installmentColumns.length
      ? (100 - fixedWidth) / installmentColumns.length
      : 0;

  return (

    <Document>

      <Page size="A4" style={styles.page}>

        <Header
          institute={institute}
          standardName={standardName}
          sectionName={sectionName}
        />

        <View style={styles.table}>

          <View style={[styles.row, styles.head]}>
            <Text style={[styles.cell, { flex: 0.5 }]}>#</Text>

            <Text style={[styles.cell, { flex: 2.5 }]}>
              Student
            </Text>

            <Text style={[styles.cell, { flex: 1 }]}>
              Class-Sec
            </Text>

            {installmentColumns.map(column => (
              <Text
                key={column}
                style={[styles.cell, { flex: 1 }]}
              >
                {column}
              </Text>
            ))}

            <Text style={[styles.cell, { flex: 1 }]}>
              Total
            </Text>
          </View>
          {
            students.map((student, index) => (
              <View key={index} style={styles.row}>
                <Text style={[styles.cell, { flex: 0.5 }]}>
                  {index + 1}
                </Text>

                <Text style={[styles.cell, { flex: 2.5 }]}>
                  {student.studentName}
                </Text>

                <Text style={[styles.cell, { flex: 1 }]}>
                  {student.className}
                </Text>

                {installmentColumns.map(column => (
                  <Text
                    key={column}
                    style={[styles.cell, { flex: 1 }]}
                  >
                    {student.installments?.[column]?.due ?? 0}
                  </Text>
                ))}

                <Text style={[styles.cell, { flex: 1 }]}>
                  {student.totalDue}
                </Text>
              </View>

            ))
          }

        </View>
        <View style={[styles.row, styles.head]}>

          <Text
            style={[
              styles.cell,
              {
                width: "43.5%", // 5% + 25% + 10%
                fontWeight: "bold"
              }
            ]}
          >
            Grand Total
          </Text>

          {installmentColumns.map(column => (
            <Text
              key={column}
              style={[
                styles.cell,
                {
                  width: `${dynamicWidth}%`,
                  fontWeight: "bold"
                }
              ]}
            >
              {grandTotals[column]}
            </Text>
          ))}

          <Text
            style={[
              styles.cell,
              {
                width: "12%",
                fontWeight: "bold"
              }
            ]}
          >
            {overallTotal}
          </Text>

        </View>
      </Page>

    </Document>

  );

};

export default DueReport;